import { useCallback, useMemo } from 'react';
import { useRouter } from 'next/router';

import { generateUrl } from '../../common/helpers/office.utils';
import { IOffice } from '../../common/model/office.model';

import { SimpleMap } from '../shared';

type Props = {
  offices: IOffice[];
};

const OfficeMap: React.FC<Props> = ({ offices }) => {
  const router = useRouter();

  const latLongArray = useMemo(
    () =>
      offices.map((office) => ({
        key: office.id,
        lat: office.lat,
        long: office.long,
      })),
    [offices]
  );

  const navigateToOffice = useCallback(
    (officeId: string) => {
      const office = offices.find((office) => office.id === officeId);
      if (!office) {
        return;
      }

      if (!router.query.slug) {
        router.push(generateUrl(office));
      }
    },
    [offices, router]
  );

  return <SimpleMap latLongArray={latLongArray} onClick={navigateToOffice} />;
};

export default OfficeMap;
